import React from 'react';
import { StyleSheet, View } from 'react-native';

/*
 * For our theme to be correctly applied and dynamically set on the web, we
 * attach it on `window` in _document.tsx. We have to avoid requiring
 * src/styles and util/environment prior to `window` being modified, so skip SSR.
 * Using dynamic imports to skip ssr with next/dynamic does not work
 * it's likely a webpack issue with the withExpo config from @expo/next-adapter
 * So, do that hacky version and literally only require on the browser.
 */

let SafeComponent: React.FC | null = null;
if (typeof window !== 'undefined') {
  // Configure NetInfo to use a static file for reachability checks
  // to bypass the subdomain check in _document.tsx
  const NetInfo = require('@react-native-community/netinfo');
  NetInfo.configure({
    reachabilityUrl: '/ping.txt',
  });

  SafeComponent = require('../src/expo-app').ExpoApp;
}

export default function App() {
  return (
    <View style={styles.container}>
      {SafeComponent ? <SafeComponent /> : null}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },
});
